import { DIMENSION_WRAPPER_ID } from '@components/dimension-panel-hz/utils';
import { SUMMARY_PANEL_CONTROLS_ID } from '../SummaryContainer/utils';

export const COMPARE_FILTERS_BAR_ID = 'compare-filters-bar';

export const scrollToTables = () => {
  const dimensionWrapper = document.getElementById(DIMENSION_WRAPPER_ID);
  if (dimensionWrapper) {
    setTimeout(() => {
      dimensionWrapper.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }, 0);
  }
};

export const scrollToCompareFiltersBar = () => {
  const summaryPanel = document.getElementById(SUMMARY_PANEL_CONTROLS_ID);
  if (summaryPanel) {
    setTimeout(() => {
      summaryPanel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    },0);
  }
};

export const COMPARE_SERIES_LOADING_STATE_EVENT = 'compare-series-loading-state-event';

export const dispatchComparLoadingStateChangeEvent = (eventDetail) => {
  const loadingEvent: any = new CustomEvent(COMPARE_SERIES_LOADING_STATE_EVENT, {
    detail: eventDetail,
  });
  document.dispatchEvent(loadingEvent);
};
